import { PRODUCT_TYPE_E_COUPON } from '~/pages/e-coupon/constants';
import type { OAISchema } from '~/types/openapi';

import WideECouponProductCard from './WideECouponProductCard';
import WideProductCard from './WideProductCard';

interface Props {
  products: OAISchema['MarketSelectProductResponseV2'][];
  eventOption?: Record<string, unknown>;
}

const EventProductWideDisplay = ({ products, eventOption }: Props) => {
  return (
    <>
      {products.map((product) => {
        return (
          <div className="[&+&]:mt-16" key={product.offerId}>
            {product.productType === PRODUCT_TYPE_E_COUPON ? (
              <WideECouponProductCard {...product} eventOption={eventOption} />
            ) : (
              <WideProductCard {...product} eventOption={eventOption} />
            )}
          </div>
        );
      })}
    </>
  );
};
export default EventProductWideDisplay;
